import useSWRMutation from "swr/mutation";
import useHttpClient from "../useHttpClient";

interface ToggleResult {
  earlyPaymentEnabled: boolean;
  requested: any | null;
}

const useEarlyPaymentToggle = () => {
  const httpClient = useHttpClient();
  return useSWRMutation(
    "early-payment-toggle",
    async (_key: string, { arg }: { arg: { enabled: boolean } }): Promise<ToggleResult> =>
      httpClient.put("/loans/early-payment", arg).then((res) => res.data.data)
  );
};

export default useEarlyPaymentToggle;
